<template>
  <el-container>
    <!-- 导出对话框 -->
    <el-dialog :title="outputdlg.title" :visible.sync="outputdlg.visible" :width="outputdlg.width">
      <el-tabs type="border-card" v-model="outputdlg.selectType">
        <el-tab-pane label="工单列表" name="0">
          <el-form :model="outputdlg" ref="outputRef" status-icon label-width="80px">
            <el-form-item label="时间区间" prop="dateRangeValue">
              <el-date-picker v-model="outputdlg.dateRangeValue" type="daterange" start-placeholder="开始日期"
                end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" />
            </el-form-item>
            <el-form-item label="转办单位" prop="unitIds">
              <el-select v-model="outputdlg.unitIds" placeholder="请选择" filterable multiple collapse-tags>
                <el-option v-for="unit in data.units.filter(
                  (item) => item.name != '所有单位'
                )" :key="unit.id" :label="unit.name" :value="unit.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="工单类型" prop="pstType">
              <el-select v-model="outputdlg.pstTypes" placeholder="请选择" multiple collapse-tags>
                <el-option v-for="pstType in pstApi.pstTypes.filter(
                  (item) => item.value != -1
                )" :key="pstType.value" :label="pstType.title" :value="pstType.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="工单状态" prop="categorys">
              <el-select v-model="outputdlg.categorys" placeholder="请选择" filterable multiple collapse-tags>
                <el-option v-for="order in pstApi.pstorders" :key="order.value" :label="order.title"
                  :value="order.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="领域选项" prop="domains">
              <el-select v-model="outputdlg.domains" placeholder="请选择" filterable multiple collapse-tags>
                <el-option v-for="domain in domaindlg.domains" :key="domain" :label="domain" :value="domain">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="单位考核表" name="1">
          <el-form :model="outputdlg" ref="kaoheRef" status-icon label-width="80px">
            <el-form-item label="时间区间" prop="dateRangeKaoheValue">
              <el-date-picker v-model="outputdlg.dateRangeKaoheValue" type="daterange" start-placeholder="开始日期"
                end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" />
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="output" :disabled="(outputdlg.selectType == '0' && outputdlg.dateRangeValue == null) ||
          (outputdlg.selectType == '1' &&
            outputdlg.dateRangeKaoheValue == null)
          ">导 出</el-button>
        <el-button @click="outputdlg.visible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 领域设置 -->
    <el-dialog :title="domaindlg.title" :visible.sync="domaindlg.dialogFormVisible" :width="domaindlg.dialogWidth">
      <!-- <el-card class="box-card"> -->
      <el-radio-group v-model="domaindlg.domain" size="medium">
        <el-radio-button :label="tag" v-for="(tag, index) in domaindlg.domains" :key="index" />
      </el-radio-group>
      <!-- </el-card> -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateDomain()" :disabled="domaindlg.domain == ''">确 定</el-button>
        <el-button @click="domaindlg.dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 疑难件审核 -->
    <el-dialog :title="problemdlg.title" :visible.sync="problemdlg.visible" :width="problemdlg.width">
      <el-form :model="problemdlg" ref="problemRef" status-icon label-width="80px">
        <el-form-item label="工单标题" prop="pstTitle">
          <el-input v-model="problemdlg.pstTitle" disabled />
        </el-form-item>
        <el-form-item label="申请原因" prop="message">
          <el-input type="textarea" :rows="3" v-model="problemdlg.message" disabled />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="problem(true)">通过</el-button>
        <el-button @click="problem(false)">不通过</el-button>
        <el-button @click="problemdlg.visible = false">取消</el-button>
      </div>
    </el-dialog>

    <!-- 延期审核 -->
    <el-dialog :title="extensiondlg.title" :visible.sync="extensiondlg.visible" :width="extensiondlg.width">
      <el-form :model="extensiondlg" ref="extensionRef" status-icon label-width="80px">
        <el-form-item label="工单标题" prop="pstTitle">
          <el-input v-model="extensiondlg.pstTitle" disabled />
        </el-form-item>
        <el-form-item label="延期天数" prop="extension">
          <el-input v-model="extensiondlg.extension" />
        </el-form-item>
        <el-form-item label="申请原因" prop="message">
          <el-input type="textarea" :rows="3" v-model="extensiondlg.message" disabled />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="extension(true)">通过</el-button>
        <el-button @click="extension(false)">不通过</el-button>
        <el-button @click="extensiondlg.visible = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 主体内容 -->
    <el-header style="display: flex; align-items: center; justify-content: space-between">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>工单列表</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button-group>
        <el-button type="info" icon="el-icon-download" @click.native="outputdlg.visible = true">导出Excel</el-button>
      </el-button-group>
    </el-header>

    <el-main>
      <div>
        <!-- 查询工具栏-->
        <div class="cust_seach">
          <el-select class="btnLeft" v-model="query.unitId" placeholder="请选择单位" filterable @change="querySubmit()">
            <el-option v-for="unit in data.units" :key="unit.id" :label="unit.name" :value="unit.id" />
          </el-select>
          <el-select v-model="query.pstType" placeholder="请选择" class="btnLeft" @change="querySubmit">
            <el-option v-for="pstType in pstApi.pstTypes" :key="pstType.value" :label="pstType.title"
              :value="pstType.value">
            </el-option>
          </el-select>
          <el-select multiple collapse-tags style="margin-left: 20px" v-model="query.categorys" placeholder="请选择"
            class="btnStatus" @change="querySubmit">
            <el-option v-for="category in pstApi.categorys.filter(
              (item) => item.value != 4 && item.value != -10
            )" :key="category.value" :label="category.transferTitle" :value="category.value">
            </el-option>
          </el-select>
          <el-input class="btnTitle" suffix-icon="el-icon-search" v-model="query.queryString" placeholder="请输入模糊字段"
            @input="querySubmit" />
          <!-- <el-button-group>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="querySubmit"
            />
          </el-button-group> -->
        </div>
        <!-- 表格 -->
        <el-table :data="data.psts" @cell-click="cellclick">
          <el-table-column prop="postingTime" label="发贴时间" width="100" align="center">
            <template slot-scope="scope">
              <div>
                {{ Common.dateFormatter(scope.row.postingTime, "yyyy-MM-dd") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="发贴人" width="150" align="center" />
          <el-table-column prop="title" label="标题">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="small" @click="details(scope.row.id)">
                  {{ scope.row.title }}
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="pstSource" label="舆情来源" width="120" align="center">
            <template slot-scope="scope">
              <div>
                <a :href="scope.row.pstUrl" target="_blank">{{
                  scope.row.pstSource
                }}</a>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="transferUnitName" label="办理单位" width="150" align="center" />
          <el-table-column prop="lastTime" label="办理时间" width="150" align="center">
            <template slot-scope="scope">
              <span v-html="getColorTime(scope.row)" />
            </template>
          </el-table-column>
          <el-table-column prop="domain" label="所属领域" width="100" align="center" />
          <el-table-column prop="status" label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === -2 ||
                scope.row.status === 0 ||
                scope.row.status === 2 ||
                scope.row.status === 3
                ? 'success'
                : 'info'
                " disable-transitions>{{ pstApi.getStatusTransferTitle(scope.row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-link type="danger" icon="el-icon-delete" :underline="false"
                @click.native="deletePst(scope.row)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="cust_pagin">
          <el-pagination layout="prev, pager, next" :total="xpagination.totalCount" :page-size="xpagination.pageSize"
            :current-page="xpagination.pageNumber" @current-change="handleCurrentChange" hide-on-single-page
            :background="true" />
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  beforeRouteLeave(to, from, next) {
    this.saveStore();
    next(); // 继续后续的导航解析过程
  },
  created() {
    this.pstApi.setWindowTitle("工单列表");
    this.getUnits(); //读取所有单位信息
    if (this.$store.state.pstQuery) {
      this.query = this.$store.state.pstQuery.query;
      this.xpagination = this.$store.state.pstQuery.xpagination;
    }
    this.getWebsiteParameter();
    this.getPstList(); //读取分页信息
  },
  mounted() {
    // 将vue实例的方法绑定到window对象中去
    window.problemShow = this.problemShow;
    window.extensionShow = this.extensionShow;
  },
  data() {
    return {
      //数据项
      data: {
        units: [], //单位数据
        psts: [], //舆情信息
      },
      //搜索栏数据
      query: {
        unitId: "00000000-0000-0000-0000-000000000000", //单位信息
        pstType: -1, //类别
        categorys: [-2, 0, 1, 2, 3], //状态
        queryString: "", //模糊字段
        isSubmit: 1,
      },
      //分页栏数据
      xpagination: {
        totalCount: 1,
        pageSize: 10,
        pageNumber: 1,
        totalPages: 1,
      },
      //导出对话框
      outputdlg: {
        title: "导出Excel文件",
        visible: false,
        width: this.ISMOBILE ? "100%" : "500px",
        // customTitle:['工单列表'],
        selectType: 0,
        dateRangeValue: null,
        unitIds: [],
        pstTypes: [],
        categorys: [],
        domains: [],
        //考核表参数
        dateRangeKaoheValue: null,
      },
      //领域对话框
      domaindlg: {
        title: "请选择工单所属领域",
        dialogFormVisible: false,
        dialogWidth: this.ISMOBILE ? "100%" : "650px",
        domains: "",
        domain: "",
        pstId: "",
      },
      problemdlg: {
        title: "申请疑难件审核",
        visible: false,
        width: this.ISMOBILE ? "100%" : "400px",
        pstId: "",
        pstTitle: "",
        extension: 0,
        message: "",
      },
      extensiondlg: {
        title: "申请延期审核",
        visible: false,
        width: this.ISMOBILE ? "100%" : "500px",
        pstId: "",
        pstTitle: "",
        extension: 0,
        message: "",
      },
    };
  },
  methods: {
    saveStore() {
      this.$store.commit("setPstQuery", {
        query: this.query,
        xpagination: this.xpagination,
      });
    },
    //查询方法部分
    querySubmit() {
      this.xpagination.pageNumber = 1;
      this.getPstList();
    },
    getUnits() {
      this.data.units = [
        {
          id: "00000000-0000-0000-0000-000000000000",
          name: "所有单位",
        },
      ];
      this.userApi.getUnitAll().then((res) => {
        var data = res.data;
        this.data.units = this.data.units.concat(data);
      });
    },
    getPstList() {
      //保存store
      this.saveStore();
      //查询
      this.pstApi
        .getPstList(
          this.query.unitId,
          this.query.pstType,
          this.query.categorys,
          this.query.queryString,
          this.xpagination.pageNumber,
          this.xpagination.pageSize,
          this.query.isSubmit
        )
        .then((res) => {
          var data = res.data;
          this.data.psts = data;
          // console.log(data);
          var pagin = JSON.parse(res.headers.xpagination);
          //console.log(pagin)
          this.xpagination.totalCount = parseInt(pagin.totalCount);
          this.xpagination.pageSize = parseInt(pagin.pageSize);
          this.xpagination.pageNumber = parseInt(pagin.currentPage);
          this.xpagination.totalPages = parseInt(pagin.totalPages);
        })
        .catch((error) => {
          //var message = error.response.data;
          //console.log('err:'+message)
          this.$toast("读取失败");
        });
    },
    //分页操作
    handleCurrentChange(val) {
      this.xpagination.pageNumber = val;
      this.getPstList();
    },

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    details(pstId) {
      //保存store
      this.saveStore();
      //调用详情
      this.$router.push({ name: "Details", params: { id: pstId } });
    },
    getColorTime(row) {
      if (row.timeIntervalString) {
        let timeIntervalString = row.timeIntervalString.replace(/-/g, "");
        var reg1 = /^剩余([9876543]{1,1}|[0123456789]{2,})天/;
        var reg2 = /^剩余[2]{1,1}天/;
        var color = "red";
        if (reg1.test(timeIntervalString)) {
          color = "green";
        } else if (reg2.test(timeIntervalString)) {
          color = "orange";
        } else if (row.extension > 0 && row.isExtension == false) {
          return `<input class='p-2' type='button' value='${timeIntervalString}' onclick="extensionShow('${row.id}','${row.title}','${row.extension}','${row.extensionMessage}')" />`;
        } else if (row.extension < 0 && row.isExtension == false) {
          return `<input class='p-2' type='button' value='${timeIntervalString}' onclick="problemShow('${row.id}','${row.title}','${row.extension}','${row.extensionMessage}')" />`;
        }

        return `<font color=${color}>${timeIntervalString}</font>`;
      } else {
        return this.Common.dateFormatter(row.lastTime, "yyyy-MM-dd hh:mm");
      }
    },

    cellclick(row, column, cell, event) {
      if (column.label == "所属领域") {
        //this.$toast(row.title)
        this.domaindlg.pstId = row.id;
        this.domaindlg.domain = row.domain;
        this.domaindlg.dialogFormVisible = true;
      }
    },
    updateDomain() {
      this.domaindlg.dialogFormVisible = false;
      // this.$toast(this.domaindlg.domain);
      this.pstApi
        .updatePstDomain(this.domaindlg.pstId, this.domaindlg.domain)
        .then((res) => {
          this.$toast("修改成功");
          this.getPstList();
        });
    },
    getWebsiteParameter() {
      this.pstApi
        .getWebsiteParameters()
        .then((resp) => {
          //读取成功
          var data = resp.data;
          this.domaindlg.domains = data.domains;
        })
        .catch((error) => {
          var message = error.response.data.Message;
          if (message == null) {
            message = "服务器访问失败";
          }
          this.$toast(message);
        });
    },
    //疑难件审核
    problemShow(pstId, title, extension, message) {
      this.problemdlg.pstId = pstId;
      this.problemdlg.pstTitle = title;
      this.problemdlg.extension = extension;
      this.problemdlg.message = message;

      this.problemdlg.visible = true;
    },
    problem(pass) {
      let pstId = this.problemdlg.pstId;
      let extension = pass ? -1 : 0;
      this.pstApi
        .pstReplyExtensionAudit(pstId, extension)
        .then((res) => {
          this.problemdlg.visible = false;
          this.$toast("疑难件审核完成");
          this.getPstList();
        })
        .catch((error) => {
          var message = error.response.data.Message;
          if (message == null) {
            message = "服务器访问失败";
          }
          this.$toast(message);
        });
    },
    //延期审核
    extensionShow(pstId, title, extension, message) {
      this.extensiondlg.pstId = pstId;
      this.extensiondlg.pstTitle = title;
      this.extensiondlg.extension = extension;
      this.extensiondlg.message = message;

      this.extensiondlg.visible = true;
    },
    extension(pass) {
      let pstId = this.extensiondlg.pstId;
      let extension = pass ? parseInt(this.extensiondlg.extension) : 0;
      if (pass && extension <= 0) {
        this.$toast("延期天数应大于0天");
        return;
      }
      this.pstApi
        .pstReplyExtensionAudit(pstId, extension)
        .then((res) => {
          this.extensiondlg.visible = false;
          this.$toast("延期审核完成");
          this.getPstList();
        })
        .catch((error) => {
          var message = error.response.data.Message;
          if (message == null) {
            message = "服务器访问失败";
          }
          this.$toast(message);
        });
    },
    //导出Excel
    output() {
      //console.log(this.outputdlg);
      this.outputdlg.visible = false;
      let selectType = this.outputdlg.selectType;
      if (selectType == "0") {
        let dateRangeValues = this.outputdlg.dateRangeValue;
        let unitIds = this.outputdlg.unitIds;
        let pstTypes = this.outputdlg.pstTypes;
        let categorys = this.outputdlg.categorys;
        let domains = this.outputdlg.domains;
        this.pstApi
          .exportPstList(dateRangeValues, unitIds, pstTypes, categorys, domains)
          .then((res) => {
            // 处理返回的文件流
            let startTime = this.Common.dateFormatter(
              dateRangeValues[0],
              "yyyyMMdd"
            );
            let endTime = this.Common.dateFormatter(
              dateRangeValues[1],
              "yyyyMMdd"
            );
            const content = res.data;
            const fileName = `（${startTime}-${endTime}）工单导出列表.xlsx`;
            this.downloadFile(
              content,
              fileName,
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            );
            this.$toast("导出成功");
          })
          .catch((error) => {
            this.$toast(error.response.data.Message);
          });
      } else if (selectType == "1") {
        let dateRangeValues = this.outputdlg.dateRangeKaoheValue;
        this.WXPstAxios({
          method: "post",
          url: "/super/export/examine",
          data: {
            DateRangeValues: dateRangeValues,
          },
          responseType: "blob",
        })
          .then((res) => {
            // 处理返回的文件流
            let startTime = this.Common.dateFormatter(
              dateRangeValues[0],
              "yyyyMMdd"
            );
            let endTime = this.Common.dateFormatter(
              dateRangeValues[1],
              "yyyyMMdd"
            );
            const content = res.data;
            const fileName = `（${startTime}-${endTime}）单位工单考核表.xlsx`;
            this.downloadFile(
              content,
              fileName,
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            );
            this.$toast("导出成功");
          })
          .catch((err) => { });
      }
    },
    // 文件流解析并下载
    downloadFile(content, fileName, type) {
      const blob = new Blob([content], { type: type });
      if ("download" in document.createElement("a")) {
        // 非IE下载
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      } else {
        // IE10+下载
        navigator.msSaveBlob(blob, fileName);
      }
    },
    deletePst(row) {
      var title = row.title;
      if (title.length > 12) {
        title = title.substr(0, 12) + "...";
      }
      this.$confirm(`确定删除【${title}】工单吗？`, "警告", {
        iconClass: "el-icon-warning", //自定义图标样式
        confirmButtonText: "确认", //确认按钮文字更换
        cancelButtonText: "取消", //取消按钮文字更换
        showClose: true, //是否显示右上角关闭按钮
        type: "warning", //提示类型  success/info/warning/error
      })
        .then(() => {
          let pstId = row.id;
          this.pstApi
            .deletePst(pstId)
            .then((res) => {
              this.$toast("删除成功");
              this.getPstList();
            })
            .catch((error) => {
              this.$toast(error.response.data.Message);
            });
        })
        .then((data) => {
          //取消操作
        })
        .catch((err) => {
          //捕获异常
          console.log(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog__body {
  padding: 0px 10px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}

//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  width: 100%;
  padding: auto 5px;

  .btnLeft {
    flex: 1;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }

  .btnTitle {
    flex: 2;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }

  .btnStatus {
    flex: 1;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }

  .el-button-group>.el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}

.el-select {
  float: left;
}

.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}

/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}

/deep/.el-textarea.is-disabled .el-textarea__inner {
  background-color: #fefefe;
  border-color: #e4e7ed;
  color: #031944;
  cursor: auto;
}

/deep/.el-input.is-disabled .el-input__inner {
  background-color: #fefefe;
  border-color: #e4e7ed;
  color: #031944;
  cursor: auto;
}
</style>